import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formLabelAlign",
      rules: _ctx.rules,
      model: _ctx.updateForm,
      "label-width": "100px",
      style: {"margin-top":"35px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "当前密码",
          prop: "oldPassword"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "password",
              minlength: "6",
              maxlength: "15",
              "show-password": "",
              placeholder: "请输入当前密码",
              modelValue: _ctx.updateForm.oldPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updateForm.oldPassword) = $event)),
              modelModifiers: { trim: true }
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, {
          label: "新密码",
          prop: "newPassword"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "password",
              minlength: "6",
              maxlength: "15",
              "show-password": "",
              placeholder: "请输入新密码",
              modelValue: _ctx.updateForm.newPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updateForm.newPassword) = $event)),
              modelModifiers: { trim: true }
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, {
          label: "确认密码",
          prop: "checkPassword"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "password",
              minlength: "6",
              maxlength: "15",
              "show-password": "",
              placeholder: "请再次输入新密码",
              modelValue: _ctx.updateForm.checkPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.updateForm.checkPassword) = $event)),
              modelModifiers: { trim: true }
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"20%","margin-top":"68px"},
          onClick: _ctx.back
        }, {
          default: _withCtx(() => [
            _createTextVNode("返回首页")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"20%","margin-top":"68px"},
          onClick: _ctx.save
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["rules", "model"])
  ]))
}